import { Box, Card, ListItem, styled } from '@mui/material'

export const StyledListItem = styled(ListItem)({
  padding: 0,
  maxHeight: '340px',
  margin: '8px 0',
})

export const StyledCard = styled(Card)(({ theme }) => ({
  display: 'flex',
  width: '100%',
  height: '100%',
  borderRadius: theme.spacing(2),
  padding: theme.spacing(1),
  marginBottom: theme.spacing(1),
  boxShadow: 'none',
  border: `1px solid ${theme.palette.divider}`,
  overflow: 'hidden',
  minWidth: 0,
}))

export const QualificationsContainer = styled(Box)({
  maxHeight: '150px',
  overflow: 'hidden',
  display: 'flex',
  flexShrink: 0,
  minWidth: 0,
  flexDirection: 'column',
})
